/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".warranty-title[_ngcontent-%COMP%]{font-size:35px;line-height:35px;margin-bottom:20px}@media (min-width:992px){.warranty-title[_ngcontent-%COMP%]{margin-bottom:30px}}.warranty-logo[_ngcontent-%COMP%]{width:50%}@media (min-width:768px){.warranty-logo[_ngcontent-%COMP%]{width:100%}}"];
export { styles as styles };
